import React from "react";
import "./Bio.css";
import PresentationHeroWebp from "../../assets/img/Pix.webp";
import PresentationHeroPng from "../../assets/img/Pix.png";
import { Link } from "react-router-dom";
import SEO from "../../helpers/SEO";

const Bio = () => {
    return (
        <div className="container">
            <div className="hero">
                <div className="hero-content-container">
                    <SEO title={"À propos"} seoTitle={"À propos"}
                        seoDescription={"Je suis traducteur en profession libérale. Je traduis des articles de presse, de la littérature, ainsi que différents types de textes politiques et diplomatiques."}
                        seoBanner={PresentationHeroPng} />
                    <div className="hero-content">
                        <div>
                            <div className="line-container">
                                <div className="line" />
                                <h5>À propos</h5>
                            </div>
                            <h1>Guillaume Deneufbourg</h1>
                        </div>
                        <div className="h4-container">
                            <p className="regular">
                                Je suis traducteur en profession libérale. Je traduis des articles de presse, de la
                                littérature et différents types de documents, rapports et allocutions politiques et
                                diplomatiques. Vous trouverez plus de détails sur mon parcours dans la biographie
                                ci-dessous.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="hero-image">
                    <picture>
                        <source srcSet={PresentationHeroWebp} type="image/webp" />
                        <source srcSet={PresentationHeroPng} type="image/png" />
                        <img
                            src={PresentationHeroPng}
                            alt="Guillaume Deneufbourg"
                            height={630}
                        />
                    </picture>

                </div>
            </div>

            <div className="bio-content">
                <div>
                    <h3>Mon parcours</h3>
                    <p className="regular">
                        Traducteur du néerlandais et de l’anglais au français depuis 2002, j’ai touché à pas mal de domaines depuis mes débuts dans la traduction, de la culture (musées, expos) aux institutions internationales, en passant par le militaire, le tourisme, le sport et même le médical. Au fil du temps, j’ai progressivement recentré ma pratique et me consacre aujourd’hui exclusivement à deux grands domaines :
                    </p>
                    <ul>
                        <li>
                            <p className="regular">
                                Rédactionnel : presse/journalisme, littérature (fiction et non-fiction), arts et culture.
                            </p>
                        </li>
                        <li>
                            <p className="regular">
                                Diplomatie et affaires gouvernementales : institutions (inter)nationales, politique, droit international.
                            </p>
                        </li>

                    </ul>
                    <p className="regular">
                        Je traduis ainsi des livres de fiction et de non-fiction, ainsi que de la poésie, des pièces de théâtre et pour divers magazines (littéraires), dont Le Courrier international. Je suis également traducteur, mais aussi coordinateur des traductions, pour le site d’actualités <a href={"http://www.daardaar.be/"} target="_blank">DaarDaar</a>.
                    </p>
                    <br />
                    <p className="regular">
                        Fin 2025, j’ai eu l’immense honneur de succéder à l’un de mes maîtres à penser dans la traduction, M. Philippe Noble, à la direction de la Collection « Lettres néerlandaises » chez <a href={"https://actes-sud.fr/recherche/catalogue/collection/1466?keys=&verified=passed"} target="_blank">Actes Sud</a> (Arles, France), où j’accompagne quelques traductions d’essais littéraires et de romans – réalisées par d’autres – en coordonnant l’ensemble de la chaîne éditoriale, de la découverte du titre en néerlandais à la publication de sa traduction française en librairie.
                    </p>
                    <br />

                    <p className="regular">
                        J’ai aussi eu le privilège de recevoir quelques récompenses pour mon travail de traduction.
                    </p>
                    <ul>
                        <li>
                            <p className="regular">
                                En 2017, j’ai été sélectionné pour le Prix Révélation de Traduction de la Société des Gens de Lettres pour ma traduction intitulée « N’écrire pour personne » du recueil de nouvelles poétiques « Belangrijk is dat ik niet aan lezers denk », de l’écrivain néerlandais A.L. Snijders.
                            </p>
                        </li>
                        <li>
                            <p className="regular">
                                En 2019, j’ai remporté le Premier prix <a href={"https://www.un.org/dgacm/fr/content/quatorzième-concours-de-traduction-saint-jérôme"} target="_blank">Saint-Jérôme</a> des Nations Unies. J’ai décroché la deuxième place de ce même concours l’année suivante, en 2020.
                            </p>
                        </li>
                        <li>
                            <p className="regular">
                                En 2023, ma traduction « Au Bord » (De Randen, Julliard) de l’auteur flamand Angelo Tijssens a remporté le Prix du Roman GAY (Mention spéciale du jury - Roman étranger).
                            </p>
                        </li>
                        <li>
                            <p className="regular">
                                En 2025, ma traduction « Au Crépuscule » du romancier néerlandais Jaap Robben (Schemerleven), publiée chez Gallmeister, a remporté le prix de traduction littéraire <a href={"https://www.euregio-lit.eu/fr/actualites/news/detail/remise-du-prix-litteraire-des-lyceens-de-l-euregio-2025"} target="_blank">EUregio</a>.
                            </p>
                        </li>
                        <li>
                            <p className="regular">
                                La même année, ma traduction « Les rêves d'un Européen au XXIe siècle » de l’historien néerlandais Geert Mak, publiée chez Gallimard, a remporté l’un des plus prestigieux prix de traduction à l’échelle internationale, le Prix Aurora Borealis de la Fédération Internationale des traducteurs.
                            </p>
                        </li>
                    </ul>

                    <p className="regular">
                        Dans le domaine diplomatique, j’ai travaillé - et travaille encore - pour plusieurs institutions en tant que prestataire contractuel, notamment pour les Nations Unies, l’administration américaine (Department of State, FBI), le ministère français des Affaires étrangères, le Parlement fédéral belge et les autorités flamandes.
                    </p>
                    <br />
                    
                    <p className="regular">
                        En plus d’être un traducteur en exercice, je suis également enseignant. Passionné de linguistique et de traductologie, je mène des recherches dans ce domaine à l’Université de Mons (<a href={"https://web.umons.ac.be/fti-eii/fr/"} target="_blank">FTI-EII</a>, Belgique), où j’enseigne également la traduction. J’ai également été intervenant à l’<a href={'https://master-traduction.univ-lille.fr/'} target="_blank">Université de Lille</a> pendant 15 ans, de 2010 à 2025.
                    </p>
                    <br />

                    <p className="regular">
                        J’ai publié des articles, scientifiques et de vulgarisation, et j’ai donné pas mal de conférences et d’exposés, partout dans le monde, de même qu’une série d’interventions dans les médias. Vous retrouverez sur <a href="https://staff.umons.ac.be/guillaume.deneufbourg/pubsfr.html" target="_blank">cette page</a> une liste non exhaustive de mes publications et interventions, et des cours dont je suis titulaire.
                    </p>
                    <br />

                    <p className="regular">
                        Je suis impliqué de longue date dans le secteur associatif, où je m’efforce de défendre les intérêts de ma profession et lui donner la visibilité qu’elle mérite.
                    </p>
                    <br />

                    <p className="regular">
                        J’ai ainsi été membre du Conseil directeur de la <a href={"https://www.cbti-bkvt.org"} target="_blank">Chambre belge des traducteurs et interprètes</a>, dont j’ai assuré la
                        présidence de 2017 à 2021.
                    </p>
                    <br />

                    <p className="regular">
                        Depuis mai 2022, je représente les traducteurs, traductrices et interprètes au niveau mondial au sein de la FIT, la <a href={"https://en.fit-ift.org/"} target="_blank">Fédération internationale des traducteurs</a>, d’abord comme membre du Conseil directeur (2022-2025) et aujourd’hui comme président, ce qui constitue le plus haut niveau de représentation de ma profession à l’échelle internationale.
                    </p>
                    <br />

                    <p className="regular">
                        Je suis également (simple) membre de diverses associations, dont l’<a
                            href={"https://atlf.org/repertoire-des-traducteurs/deneufbourg/"} target="_blank">Association
                            des traducteurs littéraires de France</a> (ATLF), la <a href={"https://www.sft.fr/fr"} target="_blank">Société française des traducteurs</a> (SFT), l’<a href={"https://www.atanet.org/"} target="_blank">American Translators Association</a>{" "} (ATA), la{" "}
                        <a href={"http://societefrancaisedetraductologie-soft.fr/"} target="_blank">Société française de traductologie</a> (SoFT) et, à titre plus personnel, de{" "}
                        <a href={"https://www.mensa.org/"} target="_blank">Mensa International</a>.
                    </p>
                    <br />

                    <p className="regular">
                        Pour suivre mon actualité, je vous invite à me suivre sur les réseaux sociaux : {" "}
                        <a href={"https://www.facebook.com/GuillaumeDeneufbourg/"} target="_blank">Facebook</a>, <a
                            href={"https://www.instagram.com/guillaume_deneufbourg/"} target="_blank">Instagram</a>, <a
                                href={"https://www.linkedin.com/in/guillaumedeneufbourg/"} target="_blank">LinkedIn</a>, <a
                                    href={"https://twitter.com/GDeneufbourg"} target="_blank">Twitter</a>.
                    </p>
                    <p className="regular">
                        Vous pouvez aussi me contacter via la page <Link to={"/contact"}>Me Contacter</Link>
                    </p>
                    <br />

                </div>
            </div>

            <div className="bio-buttons-container">
                <Link to={"/"}>
                    <button className="primary-small">Mes articles</button>
                </Link>
                <Link to={"/portfolio"}>
                    <button className="primary-small">Mes traductions</button>
                </Link>
                {/*<Link to={"/grow"}>*/}
                {/*  <button className="primary-small">Grow together</button>*/}
                {/*</Link>*/}
            </div>
        </div>
    );
};

export default Bio;
